import { Style, StyleType } from "@glamcorner/gc-types/generated/types";
import dayjs from "dayjs";
import { CollectionDesignation } from "../../common/interfaces";

export enum RenderMode {
  BUY = "buy",
  RENTAL = "rental",
  SUBSCRIPTION = "subscription",
}

export const catalogueIncludesPath = (pathname: string): boolean => {
  return window.location.pathname.includes(pathname);
};

export const isClearanceCatalogue = (): boolean => {
  return catalogueIncludesPath("/clearance");
};

export const isBeautyAndWellnessCatalogue = (): boolean => {
  return catalogueIncludesPath("/beauty-and-wellness");
};

export const getRenderMode: (style: Style, collectionDesignation: CollectionDesignation) => RenderMode = (
  style,
  collectionDesignation
) => {
  // if it's a sale product (not ex-rental), we dont look at designations - sale products are just sale products.
  if (style.record_type == StyleType.SaleProduct) {
    return RenderMode.BUY;
  }

  const matchesCollectionDesignation = (collectionDesignationToMatch: CollectionDesignation) => {
    return (
      collectionDesignation === CollectionDesignation.All || collectionDesignation === collectionDesignationToMatch
    );
  };
  if (style.designations_include_rental && matchesCollectionDesignation(CollectionDesignation.OnDemand)) {
    return RenderMode.RENTAL;
  }
  if (style.designations_include_subscription && matchesCollectionDesignation(CollectionDesignation.Subscription)) {
    return RenderMode.SUBSCRIPTION;
  }
  if (style.designations_include_sale && matchesCollectionDesignation(CollectionDesignation.AvailableToBuy)) {
    return RenderMode.BUY;
  }

  // if we get here, then the style doesn't match the collection designation at all. we don't expect this happen.
  // if it does, it only makes sense to render the style based on what it is, ignoring collection designation.

  // if it's a rental and subscription style, we prefer to render it as rental, so we check for rental first
  if (style.designations_include_rental) {
    return RenderMode.RENTAL;
  }

  if (style.designations_include_subscription) {
    return RenderMode.SUBSCRIPTION;
  }

  if (style.designations_include_sale) {
    return RenderMode.BUY;
  }

  // if we get here, it must have no designations. rendering as subscription may make the most sense here,
  // because render as subscription requires fewer price fields to be present
  return RenderMode.SUBSCRIPTION;
};

export const getDaysCount = (startDateStr: string | undefined, endDateStr: string | undefined): number | undefined => {
  if (startDateStr && endDateStr) {
    const startDate = dayjs(startDateStr);
    const endDate = dayjs(endDateStr);

    const validDates = startDate.isValid() && endDate.isValid();
    const isSequential = startDate.isBefore(endDate);

    if (validDates && isSequential) {
      return endDate.diff(startDate, "day") + 1;
    }
    return undefined;
  }
  return undefined;
};
